/// event handlers for Fullstory
angular.module('PatientApp').run([
    'FullstoryService', '$rootScope',
    function(FullstoryService, $rootScope) {
        $rootScope.$on('user:changed', function(event, currentUser) {
            FullstoryService.identify(currentUser);
        });
    }
]);
